(function () {
    'ngInject';

    angular.module('app.shared.services').factory('TemplatePermissionsService', templatePermissionsService);

    function templatePermissionsService(UsersAPIService, ProductService, TemplateAccessConstants) {
        async function initTemplatePermissionSteps($scope) {
            try {
                const user = $scope.user;
                const isEditMode = ProductService.getEditMode();
                const templateId = ProductService.getProduct()?.id;

                if (!isEditMode || !templateId) {
                    $scope.canSave = true;
                    $scope.saveDisabledText = '';
                    return;
                }

                const hasAccess = await getAccessToTemplate(
                    templateId,
                    user,
                    TemplateAccessConstants.ACCESS_LEVEL_TYPES.WRITE
                );

                $scope.canSave = hasAccess;
                $scope.saveDisabledText = hasAccess
                    ? ''
                    : 'You can only view this template. You do not have permission to edit it.';
            } catch (error) {
                console.error('Error initializing permissions:', error);
                $scope.canSave = true;
                $scope.saveDisabledText = '';
            }
        }

        async function canDelete(templateId, $scope) {
            try {
                if (!templateId) {
                    return false;
                }

                const user = $scope.user;

                const hasAccess = await getAccessToTemplate(
                    templateId,
                    user,
                    TemplateAccessConstants.ACCESS_LEVEL_TYPES.DELETE
                );

                return hasAccess;
            } catch (error) {
                console.error('canDelete - Error:', error);
                return true;
            }
        }

        async function getAccessToTemplate(templateId, user, accessLevel) {
            try {
                if (!user) {
                    return true;
                }

                if (!user.ImpersonatedFromChildUser) {
                    return true;
                }

                const response = await UsersAPIService.checkTemplateAccess(templateId, accessLevel);
                const hasAccess = response && response.hasAccess;
                return hasAccess;
            } catch (error) {
                console.error('getAccessToTemplate - Error getting permissions:', error);
                return true;
            }
        }

        return {
            initTemplatePermissionSteps: initTemplatePermissionSteps,
            canDelete: canDelete
        };
    }
})();
